// extracted by mini-css-extract-plugin
export default {"DimensionsFeature":"vz_a bhk_b bhk_wb"};